import { CreateButton } from '@/components';
import type { FC } from 'react';
import { useDrawerState } from './DrawerStateProvider';

export const CreateLocalTagButton: FC = () => {
  const { setDrawerState } = useDrawerState();

  return (
    <CreateButton
      onCreate={() => {
        setDrawerState({ open: true, type: 'local-tag', isEditing: false });
      }}
    />
  );
};
